import { CommerceSubtypes, commonSubtypes, trackEvent, type sendEventProps } from '@repo/utils';

/**
 * Sends an event with the specified type and data to New Relic for the
 * commerce app.
 *
 * Never put customer personal data (DNI, names, phone, location) in `data`: events are readable by anyone with
 * New Relic access. The order flow is correlated by `uniqueId` instead.
 *
 * @param {event} event - Object containing the type of event and the data to be
 *                       sent.
 */
export const sendCommerceEvent = async (
  event: Omit<sendEventProps, 'app'> & { subtype?: CommerceSubtypes | commonSubtypes },
) => {
  trackEvent({ app: 'commerce', ...event });
};

/**
 * Readable gender for the sexTypeId the customer lookup returns.
 *
 * @param {string | number} [sexTypeId] - 2 male, 3 female.
 */
export const genderFromSexType = (sexTypeId?: string | number) =>
  `${sexTypeId}` === '2' ? 'male' : `${sexTypeId}` === '3' ? 'female' : sexTypeId ? 'other' : undefined;
